export const SERVICE_CARD_DETAIL_INSERT = 'SERVICE_CARD_DETAIL_INSERT'
export const SERVICE_CARD_DETAIL_DELETE = 'SERVICE_CARD_DETAIL_DELETE'

export default {
    SERVICE_CARD_DETAIL_DELETE,
    SERVICE_CARD_DETAIL_INSERT,
}
